import { Action, createReducer, on } from "@ngrx/store";
import * as MenusActionTypes from "../../actions/menus/menu.actions";

export interface MenusState {
  menus: any[];
  isLoading: boolean;
}

export const initialState: MenusState = {
  menus: null,
  isLoading: false,
};

const menusReducer = createReducer(
  initialState,
  on(
    MenusActionTypes.getMenus,
    (state) =>
      ({
        ...state,
        isLoading: true,
        error: null,
      } as MenusState)
  ),
  on(MenusActionTypes.loadMenus, (state, { response }) => {
    return {
      ...state,
      menus: (response as any).result || [],
      isLoading: false,
      error: null,
    };
  }),
  on(MenusActionTypes.setLoadingStartState, (state) => {
    return {
      ...state,
      isLoading: true,
      error: null,
    };
  }),
  on(MenusActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  })
);

export function reducer(state: MenusState | undefined, action: Action) {
  return menusReducer(state, action);
}
